import { useAuth } from "Infrastructure/Contexts/AuthContext";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { MenuItem, Typography, useTheme } from "@mui/material";
import { LogOut } from "lucide-react";

export const LogoutButton = () => {
  const { logout } = useAuth();
  const { colors, customFontWeight, customSpacing, radius } = useTheme();
  const { t } = useResource();

  return (
    <MenuItem
      onClick={logout}
      sx={{
        mt: customSpacing.md,
        mx: customSpacing.md,
        borderRadius: radius.md,
        height: 40,
        gap: customSpacing.md,
      }}
    >
      <LogOut size={16} color={colors.text.primary} />
      <Typography variant="body2" fontWeight={customFontWeight.medium}>
        {t(Resources.Common.SignOut)}
      </Typography>
    </MenuItem>
  );
};
